import { useFetchTwilioTokenQuery } from 'common/api/audioCallToken';
import { Attendee } from 'common/api/proctorType';
import RightPanel from 'common/components/RightPanel';
import TileViewContainer from 'components/tiles/TileViewContainer';
import AudioCallWidget from 'components/chat/AudioCallWidget';
import { markCandidateMessagesAsDeliveredInFirebase } from 'helpers/messages';
import { useAppSelector } from 'app/hooks';
import Loader from 'common/components/Loader';
import { useEffect } from 'react';

interface Props {
participant_group_id: number;
  attendees: Attendee[];
}

const Session = ({ participant_group_id, attendees }: Props) => {
  const { sessions, isSuccess } = useAppSelector((state) => state.sessionList);
  const { data: twilioToken } = useFetchTwilioTokenQuery({});

  useEffect(() => {
    if (!sessions?.length) return;
    const timer = window.setTimeout(() => {
      markCandidateMessagesAsDeliveredInFirebase(sessions);
    }, 200);
    return () => window.clearTimeout(timer);
  }, [sessions]);

  return isSuccess ? (
    <div className="flex flex-row flex-grow overflow-hidden bg-black-50">
      <div className="relative flex w-7/12">
        <div className="absolute left-3 right-3 top-3 bottom-3 overflow-scroll">
          <TileViewContainer
            sessions={sessions}
            attendees={attendees}
            participant_group_id={participant_group_id}
          />
        </div>
      </div>
      <div className="flex flex-grow w-5/12 bg-white border-l-2">
        <RightPanel sessions={sessions} attendees={attendees} />
        {twilioToken && <AudioCallWidget attendees={attendees} />}
      </div>
    </div>
  ) : (
    <Loader />
  );
};

export default Session;
